/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/. */

// AUTOGENERATED BY glean_parser v19.0.0. DO NOT EDIT. DO NOT COMMIT.

import EventMetricType from '@mozilla/glean/private/metrics/event';

/**
 * Indicates the user entered an age in the "Age" section that is 13 or below. If
 * they do this, they encounter a page that does not let them continue to register
 * their account.
 *
 * Generated from `reg.age_invalid`.
 */
export const ageInvalid = new EventMetricType(
  {
    category: 'reg',
    name: 'age_invalid',
    sendInPings: ['events'],
    lifetime: 'ping',
    disabled: false,
  },
  []
);

/**
 * User clicked on "Change email" link at the top of the registration form.
 *
 * Generated from `reg.change_email_link_click`.
 */
export const changeEmailLinkClick = new EventMetricType(
  {
    category: 'reg',
    name: 'change_email_link_click',
    sendInPings: ['events'],
    lifetime: 'ping',
    disabled: false,
  },
  []
);

/**
 * Registration Page Engagement
 * Event that indicates user engagement with the registration page, typically when
 * focusing on form fields.
 *
 * Generated from `reg.engage`.
 */
export const engage = new EventMetricType<{
  reason?: string;
}>(
  {
    category: 'reg',
    name: 'engage',
    sendInPings: ['events'],
    lifetime: 'ping',
    disabled: false,
  },
  ['reason']
);

/**
 * Passwordless OTP Change Email (Registration)
 * Event that indicates the user clicked "Use a different account" on the
 * passwordless OTP code page during registration.
 *
 * Generated from `reg.otp_change_email`.
 */
export const otpChangeEmail = new EventMetricType(
  {
    category: 'reg',
    name: 'otp_change_email',
    sendInPings: ['events'],
    lifetime: 'ping',
    disabled: false,
  },
  []
);

/**
 * Passwordless OTP Email Confirmation Resend Code (Registration)
 * Event that indicates the user requested a new OTP code during registration.
 *
 * Generated from `reg.otp_email_confirmation_resend_code`.
 */
export const otpEmailConfirmationResendCode = new EventMetricType(
  {
    category: 'reg',
    name: 'otp_email_confirmation_resend_code',
    sendInPings: ['events'],
    lifetime: 'ping',
    disabled: false,
  },
  []
);

/**
 * Passwordless OTP Code Page Engagement (Registration)
 * Event that indicates user engagement with the OTP code input field during
 * registration.
 *
 * Generated from `reg.otp_engage`.
 */
export const otpEngage = new EventMetricType(
  {
    category: 'reg',
    name: 'otp_engage',
    sendInPings: ['events'],
    lifetime: 'ping',
    disabled: false,
  },
  []
);

/**
 * Passwordless OTP Code Submit Attempt (Registration)
 * Event that indicates a user attempted to submit the OTP code during
 * registration.
 *
 * Generated from `reg.otp_submit`.
 */
export const otpSubmit = new EventMetricType(
  {
    category: 'reg',
    name: 'otp_submit',
    sendInPings: ['events'],
    lifetime: 'ping',
    disabled: false,
  },
  []
);

/**
 * Passwordless OTP Code Submit Frontend Error (Registration)
 * Emit any frontend errors that occur when a user attempts to submit the OTP code
 * during registration.
 *
 * Generated from `reg.otp_submit_frontend_error`.
 */
export const otpSubmitFrontendError = new EventMetricType<{
  reason?: string;
}>(
  {
    category: 'reg',
    name: 'otp_submit_frontend_error',
    sendInPings: ['events'],
    lifetime: 'ping',
    disabled: false,
  },
  ['reason']
);

/**
 * Passwordless OTP Code Submit Success (Registration)
 * Event that indicates the OTP code submission was successful during
 * registration.
 *
 * Generated from `reg.otp_submit_success`.
 */
export const otpSubmitSuccess = new EventMetricType(
  {
    category: 'reg',
    name: 'otp_submit_success',
    sendInPings: ['events'],
    lifetime: 'ping',
    disabled: false,
  },
  []
);

/**
 * Passwordless OTP Code Page View (Registration)
 * A successful view/load of the passwordless OTP code entry page during
 * registration.
 *
 * Generated from `reg.otp_view`.
 */
export const otpView = new EventMetricType(
  {
    category: 'reg',
    name: 'otp_view',
    sendInPings: ['events'],
    lifetime: 'ping',
    disabled: false,
  },
  []
);

/**
 * Registration Email Confirm Attempt
 * Event that indicates a user attempted to confirm their email through clicking
 * "Confirm". See Registration Visuals/Steps in this document for more visual
 * detail.'
 *
 * Generated from `reg.signup_code_submit`.
 */
export const signupCodeSubmit = new EventMetricType<{
  reason?: string;
}>(
  {
    category: 'reg',
    name: 'signup_code_submit',
    sendInPings: ['events'],
    lifetime: 'ping',
    disabled: false,
  },
  ['reason']
);

/**
 * Emit any frontend errors that occur when a user attempts to submit the code on
 * registration confirmation page.
 *
 * Generated from `reg.signup_code_submit_frontend_error`.
 */
export const signupCodeSubmitFrontendError = new EventMetricType<{
  reason?: string;
}>(
  {
    category: 'reg',
    name: 'signup_code_submit_frontend_error',
    sendInPings: ['events'],
    lifetime: 'ping',
    disabled: false,
  },
  ['reason']
);

/**
 * Registration Confirm Email Page View
 * A page view of the email confirmation step, indicating the user successfully
 * submitted their email/password information'
 *
 * Generated from `reg.signup_code_view`.
 */
export const signupCodeView = new EventMetricType<{
  reason?: string;
}>(
  {
    category: 'reg',
    name: 'signup_code_view',
    sendInPings: ['events'],
    lifetime: 'ping',
    disabled: false,
  },
  ['reason']
);

/**
 * Registration Submission Click (Attempt)
 * Event that indicates a user attempted to submit the registration form by
 * clicking
 * "Create account". This could ultimately be a success or failure.'
 *
 * Generated from `reg.submit`.
 */
export const submit = new EventMetricType(
  {
    category: 'reg',
    name: 'submit',
    sendInPings: ['events'],
    lifetime: 'ping',
    disabled: false,
  },
  []
);

/**
 * Registration Submission Attempt Success
 * Event that indicates an attempt to submit a registration (clicking "Create
 * account") was successful.'
 *
 * Generated from `reg.submit_success`.
 */
export const submitSuccess = new EventMetricType(
  {
    category: 'reg',
    name: 'submit_success',
    sendInPings: ['events'],
    lifetime: 'ping',
    disabled: false,
  },
  []
);

/**
 * Confirmation of Registration Successful.
 * Indicates an account was successfully registered and created.
 *
 * Generated from `reg.success_view`.
 */
export const successView = new EventMetricType<{
  reason?: string;
}>(
  {
    category: 'reg',
    name: 'success_view',
    sendInPings: ['events'],
    lifetime: 'ping',
    disabled: false,
  },
  ['reason']
);

/**
 * Registration Page View
 * A successful view/load event of the registration page. See here for more
 * context
 * on registration pages and steps.'
 *
 * Generated from `reg.view`.
 */
export const view = new EventMetricType(
  {
    category: 'reg',
    name: 'view',
    sendInPings: ['events'],
    lifetime: 'ping',
    disabled: false,
  },
  []
);

/**
 * User clicked on "Why do we ask" link on registration form.
 *
 * Generated from `reg.why_do_we_ask_link_click`.
 */
export const whyDoWeAskLinkClick = new EventMetricType(
  {
    category: 'reg',
    name: 'why_do_we_ask_link_click',
    sendInPings: ['events'],
    lifetime: 'ping',
    disabled: false,
  },
  []
);
